import { render, staticRenderFns } from "./editPriceDialog.vue?vue&type=template&id=6cd2643d&"
import script from "./editPriceDialog.vue?vue&type=script&lang=ts&"
export * from "./editPriceDialog.vue?vue&type=script&lang=ts&"
import style0 from "./editPriceDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports